import { render, staticRenderFns } from "./GroupsDeleteDoc.vue?vue&type=template&id=29ae04de"
import script from "./GroupsDeleteDoc.vue?vue&type=script&lang=js"
export * from "./GroupsDeleteDoc.vue?vue&type=script&lang=js"
import style0 from "./GroupsDeleteDoc.vue?vue&type=style&index=0&id=29ae04de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports